module.exports = __webpack_public_path__ + "img/emoji_145.a27dab04.png";